import React from 'react';

export function SiteSwitch({ site, setSite }) {
  return (
    <div className="site-switch">
      <button
        type="button"
        className={site === 'beziers' ? 'site-btn active' : 'site-btn'}
        onClick={() => setSite('beziers')}
      >
        Béziers
      </button>

      <button
        type="button"
        className={site === 'martigues' ? 'site-btn active' : 'site-btn'}
        onClick={() => setSite('martigues')}
      >
        Martigues
      </button>

      <button
        type="button"
        className={site === 'perpignan' ? 'site-btn active' : 'site-btn'}
        onClick={() => setSite('perpignan')}
      >
        Perpignan
      </button>
    </div>
  );
}
